const getPeAccessoryCreditOffers = trim => {
  const creditOffers = {
    firstOffer: trim?.firstOffer,
    secondOffer: trim?.secondOffer,
    thirdOffer: trim?.thirdOffer,
  };
  return creditOffers;
};

export default getPeAccessoryCreditOffers;
